import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './style/global.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.css'
import MetaInfo from 'vue-meta-info'
import VueClipboard from 'vue-clipboard2';
import pinyin from 'js-pinyin'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.use(VueClipboard);
Vue.use(MetaInfo);

Vue.use(ElementUI);
// Vue.use(Vant);

Vue.prototype.isMobile = document.documentElement.clientWidth <= 0

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  pinyin,
  render: h => h(App),
  
  mounted () {
      document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js